var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Index")]),_vm._v("\n  404\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }